"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
exports.__esModule = true;
var react_1 = __importDefault(require("react"));
var ModalV2_1 = __importDefault(require("@src/components/ModalV2"));
var button_1 = __importDefault(require("relements/build/esm/ui/button"));
var icon_1 = __importDefault(require("relements/build/esm/ui/icon"));
var text_1 = __importDefault(require("relements/build/esm/ui/text"));
var fridge_svg_1 = __importDefault(require("./Icons/fridge.svg"));
require("./EmptyTransferModal.scss");
var defaults = {
    modalActive: false,
    closeModal: function () { },
};
var EmptyTransferModal = function (_a) {
    var _b = _a === void 0 ? defaults : _a, modalActive = _b.modalActive, closeModal = _b.closeModal;
    return (react_1["default"].createElement(ModalV2_1["default"], { title: "", subtitle: "", headerIcon: null, headerSubIcon: null, active: modalActive, classPrefix: "emptyTransfer", isV2: true, toggleModal: closeModal },
        react_1["default"].createElement("div", { className: "emptyTransferHead" },
            react_1["default"].createElement(icon_1["default"], { className: "fridgeIcon", src: fridge_svg_1["default"] })),
        react_1["default"].createElement("div", { className: "emptyTransferBody" },
            react_1["default"].createElement(text_1["default"], { variant: "h2.semi-bold" }, "Nothing new to Preview & Publish"),
            react_1["default"].createElement(text_1["default"], { variant: "body.md", color: "grey.deep" }, "Looks like there is no change in the bot since the last publish was made."),
            react_1["default"].createElement(button_1["default"], { onClick: closeModal, size: "large", type: "text", themed: true }, "Continue Building Bot"))));
};
exports["default"] = EmptyTransferModal;
